import moment from "moment"

export default (time, format = "DD/MM/YYYY") => {
  return moment(time).format(format)
}
